import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

export type PlusMinusOption = '+-' | '+' | '-';

@Component({
	selector: 'app-plus-minus-sel',
	templateUrl: './plus-minus-sel.component.html',
	styleUrls: ['./plus-minus-sel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlusMinusSelComponent implements OnInit {



	private _val: PlusMinusOption;
	@Input()
	public value: PlusMinusOption = '+-';
	/*set value(val: PlusMinusOption) {
		
		if (this._val !== val) {
			this._val = val;
			this.cdr.detectChanges();
			window.requestAnimationFrame(()=>{
				this.valueChange.emit(val);
			});
		}


	}
	get value(): PlusMinusOption {
		return this._val;
	}
	*/
	@Output()
	public valueChange = new EventEmitter<PlusMinusOption>();
	constructor(private cdr: ChangeDetectorRef) { }
	ngOnInit(): void {

	}
	Update(val: PlusMinusOption) {
		this.value = val;
		this.cdr.detectChanges();
		this.cdr.markForCheck();
		this.valueChange.emit(this.value);
	}

}
